export enum ROUTES {
  Home = "/",
  AnalysisProviders = "/integrations/analysisProviders",
  Dashboard = "/dashboard",
  Vehicles = "/vehicles",
  Drivers = "/drivers",
  VehicleFiles = "/vehicleFiles",
  DriverFiles = "/driverFiles",
  Companies = "/companies",
  Users = "/users",
  UserInvitation = "/UserInvitation",
  UsersInvitations = "/users/invitations",
  RequestReset = "/requestResetPassword",
  ResetPassword = "/ResetPassword",
  Integrations = "/integrations",
  IntegrationsApi = "/integrations/apicredentials",
  NotFound = "*"
}

export enum ALL_ROUTES {
  AllRoutes = "all"
}

export enum NAVIGATION_ITEMS {
  Vehicles = "Vehicles",
  Dashboard = "Dashboard",
  Drivers = "Drivers",
  Files = "Files",
  Users = "Users",
  Companies = "Companies",
  Integrations = "Integrations"
}

export enum LOCAL_STORAGE_KEYS {
  ActiveTableColumns = "activeTableColumns", // change key name when there is a need to reset the table columns. Read more in README.md
  JwtKey = "accessToken",
  lng = "i18nextLng",
  DesktopDrawer = "desktopDrawer",
  DesktopDetailsSection = "desktopDetailsSection",
  Tokens = "tokens",
  VehiclesPageParams = "vehiclesPageParams",
  DriversPageParams = "driversPageParams",
  VehicleFilesPageParams = "vehicleFilesPageParams",
  DriverFilesPageParams = "driverFilesPageParams",
  UsersPageParams = "usersPageParams",
  UsersInvitationsPageParams = "usersInvitationsPageParams",
  IntegrationsPageParams = "integrationsPageParams",
  IntegrationsApiPageParams = "integrationsApiPageParams",
  CompaniesPageParams = "companiesPageParams",
  Contains = "contains",
  Page = "page",
  PageNumber = "pageNumber",
  SelectedTableItem = "selectedTableItem",
  ShowPerPage = "showPerPage",
  Filters = "filters",
  SelectedTableItemUrlKey = "selectedTableItemUrlKey"
}

export enum LANGUAGES {
  English = "en-US",
  Lithuanian = "lt-LT",
  German = "de-DE",
  French = "fr-FR",
  Italian = "it-IT",
  Polish = "pl-PL",
  Spanish = "es-ES",
  Hungarian = "hu-HU"
}

export enum LANGUAGE_KEYS {
  En = "En",
  Lt = "Lt",
  De = "De",
  Fr = "Fr",
  It = "It",
  Pl = "Pl",
  Es = "Es",
  Hu = "Hu"
}

export enum COLUMN_NAMES {
  ActivityPeriod = "activity period",
  CardName = "card name",
  CardNumber = "card number",
  Comment = "comment",
  Company = "company",
  CompanyId = "company id",
  ConnectionStatus = "connection status",
  CreatedAt = "created at",
  CreatedBy = "created by",
  CreditStatus = "credit status",
  dataTypes = "data types",
  Deleted = "deleted",
  Description = "description",
  DeviceImei = "device imei",
  DeviceStatus = "device status",
  Driver = "driver",
  DriverFileName = "File name",
  DriverName = "Driver name",
  DriversName = "drivers name",
  DownloadTime = "downloaded at",
  Email = "email",
  Enable = "enable",
  Enabled = "enabled",
  ExpirationDate = "expiration date",
  Id = "id",
  InvitedAt = "invited at",
  InvitedBy = "invited by",
  Imei = "imei",
  InvitationStatus = "invitation status",
  LastActivity = "last activity",
  LastConnected = "last connected",
  LastConnection = "last connection",
  LastDownload = "last download",
  LastEvent = "last event",
  LastVehicleUsed = "last vehicle used",
  Method = "method",
  Name = "name",
  NextDownload = "next download",
  Number = "number",
  ParentCompany = "parent company",
  PlateNumber = "plate number",
  Provider = "provider",
  Role = "role",
  Schedule = "schedule",
  Schedules = "schedules",
  SeenAt = "seen at",
  Status = "status",
  Type = "type",
  UpdatedAt = "updated at",
  UpdatedBy = "updated by",
  Vehicle = "vehicle",
  VehicleName = "vehicle name",
  VehicleNumber = "vehicle number",
  VehicleFileName = "file name"
}

export enum COLUMN_RESOURCES {
  ActivitiesFrom = "activitiesFrom",
  ActivitiesTo = "activitiesTo",
  CardName = "cardName",
  CardNumber = "cardNumber",
  Comment = "comment",
  Company = "company",
  CompanyId = "companyId",
  ConnectionStatus = "connectionStatus",
  CreatedAt = "createdAt",
  CreatedBy = "createdBy",
  CreditStatus = "creditStatus",
  Deleted = "deleted",
  DeviceStatus = "deviceStatus",
  Driver = "driver",
  DriverName = "driverName",
  DriversName = "driversName",
  DownloadTime = "downloadTime",
  Email = "email",
  Enabled = "enabled",
  ExpirationDate = "expirationDate",
  FileName = "fileName",
  FileTypes = "fileTypes",
  Id = "id",
  InvitedAt = "invitedAt",
  InvitedBy = "invitedBy",
  InvitationStatus = "invitationStatus",
  Imei = "imei",
  LastActivity = "lastActivity",
  LastConnected = "lastConnected",
  LastDownload = "lastDownloadAttempt",
  LastEvent = "lastEvent",
  LastVehicleNumber = "lastVehicleNumber",
  LastSuccessfulDownloadTime = "lastSuccessfulDownloadTime",
  Name = "name",
  NextDownload = "nextDownload",
  Number = "number",
  ParentCompanyName = "parentCompanyName",
  PlateNumber = "plateNumber",
  Provider = "provider",
  Role = "role",
  Schedule = "schedule",
  Schedules = "schedulesCount",
  SchedulesList = "schedulesList",
  SeenAt = "seenAt",
  SourceName = "sourceName",
  Status = "status",
  Type = "type",
  UpdatedAt = "updatedAt",
  UpdatedBy = "updatedBy",
  Vehicle = "vehicle",
  VehicleImei = "vehicleImei",
  VehicleName = "vehicleName",
  VehicleNumber = "vehicleNumber",
  VehicleFileName = "filename"
}

export enum LAST_DOWNLOAD_STATUS {
  Safe = "Safe",
  Warning = "Warning",
  Overdue = "Overdue"
}

export enum ACTIVITY_STATUS {
  Active = "Active",
  Inactive = "Inactive",
  Offline = "Offline",
  Online = "Online",
  Deactivated = "Deactivated",
  Disabled = "Disabled"
}

export enum DOWNLOAD_ACTIVITY_STATUS {
  Awaiting = "Awaiting connection",
  Successful = "Successful",
  Failed = "Failed"
}

export enum COMPANY_CARD_STATUS {
  Online = "Online",
  Offline = "Offline",
  Expired = "Expired",
  Inactive = "Inactive",
  Deactivated = "Deactivated" // faked status, used only for display purposes
}

export enum COMPANY_CARD_EXPIRY_STATUS {
  Success = "success",
  Info = "info",
  Warning = "warning",
  Critical = "critical"
}

export enum INVITATION_STATUS {
  Expired = "Expired",
  Pending = "Pending"
}

export enum INTEGRATION_STATUS {
  Active = "Active",
  Disabled = "Disabled",
  Failed = "Failed",
  Interrupted = "Interrupted",
  InvalidConfiguration = "InvalidConfiguration"
}

export enum API_CREDENTIAL_STATUS {
  Active = "Active",
  Disabled = "Disabled",
  Expired = "Expired"
}

export enum ANALYSIS_PROVIDERS_STATUS {
  Active = "Active",
  Disabled = "Disabled",
  Successful = "Successful",
  Stopped = "Stopped"
}

export enum TABLE_NAMES {
  Dashboard = "dashboard",
  Vehicles = "vehicles",
  Drivers = "drivers",
  Companies = "companies",
  Files = "files",
  Users = "users",
  Integrations = "integrations",
  IntegrationsApi = "integrations/apicredentials",
  AnalysisProviders = "integrations/analysisProviders"
}

export enum ID_TYPE {
  Id = "id",
  Imei = "imei",
  Repeat = "repeat"
}

export type Resource = COLUMN_RESOURCES | COLUMN_RESOURCES[];

export enum LOADER_SIZES {
  Medium = "medium",
  Small = "small",
  Tiny = "tiny"
}

export enum INPUT_LENGTH {
  CardHolderName = 75,
  MinCardHolderName = 3,
  Name = 255,
  Description = 255,
  Imei = 15,
  MaxPassword = 64,
  VehicleName = 30,
  CompanyName = 100,
  LzCodeMinimum = 4,
  LzCodeMaximum = 10,
  MinCompanyName = 3,
  MinCompanyCardNameLength = 3,
  MaxCompanyCardNameLength = 50,
  MinCompanyCardIdLength = 10,
  MaxCompanyCardIdLength = 55,
  MaxValueInSearchField = 80
}

export enum NEWS_INPUT_LENGTH {
  MaxTitle = 80,
  MaxDescription = 5000
}

export enum INTEGRATIONS_INPUT_LENGTH {
  Name = 200,
  Host = 255,
  Username = 128,
  InputMaxLength = 512,
  PortMin = 1,
  PortMax = 65535
}

export enum CONVEY_WEB_INPUT_LENGTH {
  Name = 200,
  EndpointUrl = 2048,
  Username = 128,
  InputMaxLength = 512
}

export enum VDO_INPUT_LENGTH {
  Name = 200,
  ApiKey = 2048,
  AccountId = 128
}

export enum API_KEY_INPUT_LENGTH {
  Name = 60
}

export enum INPUT_VALUES_LENGTH {
  Imei = 15,
  DriverId = 16
}

export enum DRIVER_INPUT_VALIDATION_STRINGS {
  DriverIdInvalid = "Dialog##driver id not valid",
  DriverIdEmpty = "Dialog##driver id should not be empty"
}

export enum MORE_ACTIONS_KEYS {
  Import = "import",
  Export = "export"
}

export enum VEHICLES_ACTIONS {
  Activate = "activate vehicle",
  AddSchedule = "add to schedule",
  AddVehicle = "add vehicle",
  AssignSchedules = "assign schedules",
  CreateSchedule = "create vehicle schedule",
  Deactivate = "deactivate vehicle",
  DeleteSchedule = "delete vehicle schedule",
  DeleteVehicle = "delete vehicle",
  DownloadStatus = "download status",
  DownloadMonitoring = "download monitoring",
  EditSchedule = "edit vehicle schedule",
  EditVehicle = "edit vehicle",
  ExportVehicle = "export vehicle",
  ImportVehicle = "import vehicle",
  MoveVehicles = "move vehicles",
  NoTableActions = "no table actions",
  QuickScheduleDownload = "vehicle schedule quick download",
  RemoveSchedules = "remove vehicle schedules",
  Schedules = "vehicle schedules"
}

export enum DRIVERS_ACTIONS {
  AddDriver = "add driver",
  AddSchedule = "add to schedule",
  CreateSchedule = "create driver schedule",
  DeleteSchedule = "delete driver schedule",
  DeleteDriver = "delete driver",
  ImportDriver = "import driver",
  ExportDriver = "export driver",
  EditSchedule = "edit driver schedule",
  EditDriver = "edit driver",
  BulkQuickScheduleDownload = "driver bulk schedule quick download",
  QuickScheduleDownload = "driver schedule quick download",
  RemoveSchedules = "remove driver schedules",
  Schedules = "driver schedules"
}

export enum VEHICLE_FILES_ACTIONS {
  Download = "download file vehicle",
  FileSettings = "file settings vehicle"
}

export enum DRIVER_FILES_ACTIONS {
  Download = "download file driver",
  FileSettings = "file settings driver"
}

export enum MAX_ALLOWED_COUNTS {
  DownloadFiles = 100
}

export enum USERS_ACTIONS {
  EditUser = "edit user",
  DeleteUser = "delete user",
  InviteUser = "invite user"
}

export enum COMPANIES_ACTIONS {
  AddNewEmailRecipient = "add new email recipient",
  CreateCompany = "create company",
  CreateNewCompanyCard = "create new company card",
  DeleteCompany = "delete company",
  EditCompany = "edit company",
  EditCompanyCard = "edit company card",
  EditEmailRecipient = "edit email recipient",
  MoveCompany = "move company",
  RemoveCompanyCard = "remove company card",
  RemoveEmailRecipient = "remove email recipient"
}

export enum INTEGRATIONS_ACTIONS {
  AddIntegration = "add integration",
  DeleteIntegration = "delete integration",
  DeleteApiCredential = "delete api credential",
  EditIntegration = "edit integration",
  RetryIntegration = "retry integration"
}

export enum INTEGRATIONS_API_ACTIONS {
  DeleteCredential = "delete api credential",
  EditCredential = "edit api credential"
}

export enum ANALYSIS_PROVIDERS_ACTIONS {
  Delete = "delete analysis provider",
  Edit = "edit analysis provider",
  Retry = "retry analysis provider"
}

export enum DATE_FORMATS {
  DateHoursMinutes = "YYYY-MM-DD HH:mm",
  DateHoursMinutesSeconds = "YYYY-MM-DD HH:mm:ss",
  Day = "DD",
  EnUsString = "DD MMMM, yyyy",
  EnUsStringShort = "DD MMM YYYY",
  Hours = "HH",
  HoursMinutes = "HH:mm",
  HoursMinutesSeconds = "HH:mm:ss",
  ISO_8601 = "YYYY-MM-DDTHH:mm:ssZ",
  ISO_8601_no_z = "YYYY-MM-DDTHH:mm:ss",
  Month = "MM",
  MonthLong = "MMM",
  MonthYear = "MMMM YYYY",
  MonthYearShort = "MMM YYYY",
  Year = "YYYY",
  DayMonthYear = "DD-MM-YYYY",
  MonthDayYear = "MM-DD-YYYY",
  YearMonthDay = "YYYY-MM-DD",
  MonthDayYearLong = "MMMM D, YYYY",
  MonthDayYearShort = "MMM D, YYYY"
}

export enum VehicleDataTypes {
  Overview = "Overview",
  EventsAndFaults = "EventsAndFaults",
  DetailedSpeed = "DetailedSpeed",
  TechnicalData = "TechnicalData",
  Activities = "Activities"
}

export enum DriverDataTypes {
  DriverCard = "DriverCard"
}

export enum FILE_UPLOAD_STATUS {
  Success = "success",
  Failed = "failed",
  Ready = "ready"
}

export enum FILE_COUNT {
  File = "file",
  Files = "files"
}

export enum FORM_DATA_KEYS {
  DriversFiles = "driversFile",
  VehiclesFiles = "vehiclesFile"
}

export enum RESOURCE_ACTIONS {
  Deleted = "deleted",
  RemovedSchedules = "removed schedules"
}

export enum NEWS_ACTIONS {
  Delete = "delete",
  EditNews = "edit news",
  OpenNew = "open new",
  Publish = "publish",
  ReleaseNotes = "release notes"
}

export enum COOKIE_NAMES {
  All = "all",
  Analytics = "analytics"
}

export enum TIME_VALUES {
  Midnight = "00:00"
}

export enum ERROR_CODES {
  BadRequest = 400,
  InternalServerError = 500,
  Unauthorized = 401
}

export enum IntegrationsErrorDialogSteps {
  Closed = "closed",
  TypeSelect = "typeSelect",
  Add = "add",
  AddApi = "addApi",
  ApiKeyGenerated = "apiKeyGenerated",
  AnalysisProviders = "analysisProviders",
  ConveyIntegrations = "conveyIntegrations",
  VDOIntegrations = "vdoIntegrations",
  Edit = "edit",
  EditConvey = "edit convey",
  EditVdo = "edit vdoFleet",
  Error = "error",
  Retry = "retry"
}

export enum VehicleErrorMessages {
  ImeiAlreadyAssignedAccessible = "IMEI is already assigned to an accessible vehicle.",
  ImeiAlreadyAssignedInaccessible = "IMEI is already assigned to a vehicle outside your access scope.",
  ImeiExists = "Vehicle with such IMEI already exists.",
  ImeiChangeError = "IMEI change requires explicit confirmation due to credit reservation in the current month.",
  VrnExists = "Vehicle with such number (VRN) already exists."
}

export enum TUTORIAL_IDS {
  AccordionDetailsCard = "accordion-details-card",
  AddNewCompanyCardComponent = "add-new-company-card-component",
  AddResourceButton = "add_resource_button",
  Body = "body",
  Checkbox0VehiclesBody = "checkbox_0_vehicles_body",
  Companies = "Companies",
  CompanyCardAuthButton = "companyCardAuthButton",
  CompanySelectorButton = "company-selector-button",
  CompanySelectorButtonToSm = "company-selector-button-to-sm",
  CompanySelectorMenu = "companySelectorMenu",
  CompanySelectorContent = "company-selector-content",
  DesktopDetailsAside = "desktop-details-aside",
  InactiveMobileHead = "inactive_mobile_head",
  MainScheduleCards = "main_schedule_cards",
  MobileDetails0Item = "mobile_details_0_item",
  MobileDrawerButton = "mobile-drawer-button",
  SchedulesDialogButton = "schedulesDialogBtn",
  SchedulesMainDialog = "schedules-main-dialog",
  SchedulesMainDialogApplyButton = "schedules-main-dialog-apply-button",
  SchedulesMainDialogCloseButton = "schedules-main-dialog-close-button",
  Row0 = "row_0",
  Vehicles = "Vehicles"
}

export enum REASSIGN_DATA_VALUES {
  CompanyName = "CompanyName",
  Imei = "Imei",
  VehicleNumber = "VehicleNumber"
}

export enum USER_INFO_LENGTHS {
  PswMin = 12,
  PswMax = 64,
  Email = 254,
  OtpMax = 6
}

export enum USER_INFO_ERROR_KEYS {
  CodeExpired = "General##code expired",
  FieldLengthNotValid = "Dialog##field length not valid",
  IncorrectCode = "Password##incorrect code",
  InvalidEmailFormat = "Auth##invalid email format",
  NumbersOnly = "Auth##enter numbers only",
  Required = "Auth##required",
  Unauthorized = "General##unauthorized"
}

export enum TRANSLATABLE_OBJECTS {
  Alert = "Alert",
  DownloadMonitoring = "Download monitoring",
  Table = "Table"
}
